import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface DetailInfoItemProps {
  name: string;
  children: ReactNode;
  required?: boolean;
  showAlert?: boolean;
  wrapperFlex?: string;
}

export default function DetailInfoItem({
  name,
  children,
  required,
  showAlert,
  wrapperFlex,
}: DetailInfoItemProps) {
  return (
    <Flex
      borderBottom="1px solid"
      borderBottomColor="lightGray300"
      flex={wrapperFlex || 'auto'}
      flexDirection={['column', null, 'row']}
    >
      <Flex
        alignItems="center"
        bg="tableBackgroundNeutralDark"
        flex="none"
        fontWeight={required ? 'medium' : 'regular'}
        height={['45px', null, 'initial']}
        px={6}
        width={['100%', null, 'max(160px, 12%)']}
      >
        {name}
        {required && <Text color="textNegativeBase">*</Text>}
        {showAlert && (
          <Text color="iconPrimaryBase" ml="auto">
            <FontAwesomeIcon icon={faExclamationCircle} />
          </Text>
        )}
      </Flex>
      <Flex alignItems="center" flex="auto" minHeight={[null, null, '60px']} px={6} py={4}>
        {children}
      </Flex>
    </Flex>
  );
}
